import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type ScrollableFormShellProps = {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  minWidthClassName?: string;
  scrollerClassName?: string;
};

export function ScrollableFormShell({
  children,
  className,
  contentClassName,
  minWidthClassName = "min-w-0",
  scrollerClassName,
}: ScrollableFormShellProps) {
  return (
    <section className={cn("min-w-0 max-w-full overflow-hidden rounded-lg border border-slate-300 bg-slate-100 shadow-sm", className)}>
      <div className={cn("min-w-0 max-w-full overflow-x-auto [scrollbar-gutter:stable]", scrollerClassName)}>
        <div className={cn("w-full max-w-full", minWidthClassName, contentClassName)}>{children}</div>
      </div>
    </section>
  );
}
